/* SAJAT - WELLPOINT Service Bundle Settings
 * VERSION: 2.0.0
 * UPDATED: 2026-09-10
 */

window.WELLPOINT_SERVICE_BUNDLE_SETTINGS = {

  version: '2.0.0',

  /*
   * DEVICE PRODUCT TITLE FILTER
   *
   * 'BUNDLE'
   *   -> csak azok a termékek számítanak Device-nak,
   *      amelyek product title-ja tartalmazza a BUNDLE szót.
   *
   * ''
   *   -> nincs title szűrés.
   *      BÁRMELY termék megfelel, ha van
   *      PRO / PLUS / LITE option value-ja.
   */

  //deviceProductTitleFilter: 'BUNDLE',
  deviceProductTitleFilter: '',


  /*
   * PLAN -> SERVICE PRODUCT
   *
   * A Device SKU / Variant ID NEM szükséges.
   */

  plans: {

    PRO:
      'people-counter-pro-plan-for-bundle-wellpoint-real-time-visitor-insights-people-counter-device-not-included',

    PLUS:
      'people-counter-plus-plan-for-bundle-wellpoint-real-time-visitor-insights-people-counter-device-not-included',

    LITE:
      'people-counter-lite-plan-for-bundle-wellpoint-real-time-visitor-insights-people-counter-device-not-included'

  }

};

/* EOF SAJAT - WELLPOINT Service Bundle Settings */